export const INITIAL_ACTIONS_STATE = Object.freeze({
  actions: {
    dispatch: null,
    flush: null,
    export: null,
    home: null,
    restore: null,
    select: null,
  },
});

export default function createActionsSlice(set, get) {
  return {
    ...INITIAL_ACTIONS_STATE,
    setActions: (actions) => {
      set({
        actions: {
          ...get().actions,
          ...actions,
        },
      });
    },
  };
}
